export default __webpack_public_path__ + "media/zurb/img/mobile-and-web-apps/equinix1-74b34faf20294fb77ba17ef4151ec45f.png";